"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Outer_1 = require("../../panels/ContentImportPanel/Outer");
const template_parser_1 = require("@osmosys/template-parser");
const hooks_1 = require("./hooks");
exports.EmailCanvasContentImportPanelOuter = () => {
    const { dispatchCanvasAction } = hooks_1.useEmailCanvasUpdate();
    const { state: { draftEmail, activeContentImportBlockIdx }, } = hooks_1.useEmailCanvasContext();
    // const dispatchCanvasAction = (...args: any[]) => {};
    return (react_1.default.createElement(Outer_1.ContentImportPanelOuter, { contentFeed: draftEmail.defaultContentFeedSecond, onClose: () => {
            dispatchCanvasAction({
                data: {
                    activeContentImportBlockIdx: null,
                },
                type: 'state',
            });
        }, onChangeContentFeed: cf => {
            if (!draftEmail.defaultContentFeedSecond ||
                !cf ||
                draftEmail.defaultContentFeedSecond.id !== cf.id) {
                dispatchCanvasAction({
                    data: {
                        draftEmail: Object.assign(Object.assign({}, draftEmail), { defaultContentFeed: cf, defaultContentFeedSecond: cf }),
                    },
                    type: 'state',
                });
            }
        }, isOpen: !!activeContentImportBlockIdx, onContentImport: ({ contentItem, contentFeed, contentSlotNumber }) => {
            if (!activeContentImportBlockIdx) {
                window.alert('Unable to import content, as Osmosys is unable to find the intended block (Error #1). Please contact customer support for assistance.');
                return;
            }
            const [newBlocks, foundBlock] = template_parser_1.updateNestedBlock(activeContentImportBlockIdx, draftEmail.blocks, {}, {
                contentFeed,
                contentItem,
                contentSlotNumber: typeof contentSlotNumber === 'number' ? contentSlotNumber : null,
            });
            if (!foundBlock) {
                window.alert('Unable to import content, as Osmosys is unable to find the intended block (Error #2). Please contact customer support for assistance.');
                return;
            }
            dispatchCanvasAction({
                data: {
                    activeContentImportBlockIdx: null,
                    draftEmail: Object.assign(Object.assign({}, draftEmail), { blocks: [...newBlocks] }),
                },
                type: 'state',
            });
        } }));
};
//# sourceMappingURL=ContentImportPanelOuter.js.map